module.exports = __webpack_public_path__ + "img/boy.7ad82f2.webp";